"use client";

import React from "react";
import { Box, Heading, BoxProps } from "@chakra-ui/react";

interface MetricsCardProps extends BoxProps {
  title: string;
  children: React.ReactNode;
}

const MetricsCard: React.FC<MetricsCardProps> = ({ 
  title, 
  children, 
  ...rest 
}) => {
  return (
    <Box 
      overflow="hidden" 
      bg="white" 
      borderRadius="md"
      borderWidth="1px"
      borderColor="gray.200"
      boxShadow="sm"
      transition="all 0.3s ease"
      _hover={{
        boxShadow: "md",
        transform: "translateY(-2px)"
      }}
      {...rest}
    >
      <Box pt={4} pb={8} px={4} w="full" minH="143px">
        <Heading as="h2" fontSize="base" fontWeight="semibold" color="black">
          {title}
        </Heading>
        {children}
      </Box>
    </Box>
  );
};

export default MetricsCard; 